// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__JMqtL","card_container":"Home_card_container__3UzfQ"};